import { ServoBikeProductType } from '@base/backend';

export const BikeProductTypeTranslations = {
  getTypeTranslation(bikeProductType: ServoBikeProductType) {
    switch (bikeProductType) {
      case ServoBikeProductType.Diebstahl:
        return 'Diebstahldeckung';
      case ServoBikeProductType.KompaktPaket:
        return 'Kompaktpaket';
      case ServoBikeProductType.PremiumPaket:
        return 'Premiumpaket';
      default:
        return '';
    }
  }
};

